import { data } from '../../svg/Numbers/data';
import { makeIcon } from '../makeIcon';

export const Numbers = makeIcon(data, 'numbers', 'Numbers');

export default Numbers;
